<template>
  <div>
    <v-row v-for="(iconObj, index) in icons" :key="index" class="mt-1">
      <!-- icon selector -->
      <v-col class="col-2">
        <s-font-awesome-select
          v-model="iconObj.icon"
          class="pb-0"
        ></s-font-awesome-select>
      </v-col>

      <!-- icon text -->
      <v-col class="col-8">
        <v-textarea
          v-model="iconObj.iconText"
          outlined
          :rows="1"
          :label="$t('singleEventView.iconText')"
          hide-details
        />
      </v-col>

      <!-- delete icon -->
      <v-col class="col-2 text-end align-self-center">
        <v-btn small color="error" @click="removeIconObject(index)">
          <i class="far fa-times"></i>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <!-- add new icon button -->
      <v-col class="col-12 align-self-center">
        <v-btn color="green" class="white--text" @click="addEmptyIconObject">
          <i class="far fa-plus mr-2" />
          {{ $t('translationIcons.addIcon') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EntityTranslations from '../../classes-shared/entityTranslations/EntityTranslations'
import SFontAwesomeSelect from '../../components-shared/utils/SFontAwesomeSelector'

export default {
  name: 'TranslationIcons',
  components: { SFontAwesomeSelect },
  props: {
    // class instance, where all the translations live
    entityTranslations: {
      type: EntityTranslations,
      required: true,
    },
    currentLanguage: {
      type: String,
      required: true,
    },
  },

  computed: {
    icons() {
      return this.entityTranslations.getTranslationByLanguageValue(
        this.currentLanguage,
        true
      ).icons
    },
  },

  methods: {
    addEmptyIconObject() {
      this.icons.push({
        icon: {
          iconName: null,
        },
        iconText: null,
      })
    },
    removeIconObject(index) {
      this.icons.splice(index, 1)
    },
  },
}
</script>
